<div class="row">
  <div class="card-columns">
    <div class="card" (click)="showModal(project)" *ngFor="let project of projects">
      <img  [src]="project.image" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">{{ project.name }}</h5>
        <p class="card-text">{{ project.desc }}</p>
        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
      </div>
    </div>
  </div>
  <!-- <div *ngFor="let project of projects" class="col-md-4 col-sm-6 portfolio-item">
    <a class="portfolio-link portafolio-modal" data-id="0" data-toggle="modal" (click)="showModal(project)" href="#portfolioModal">
      <div class="portfolio-hover">
        <div class="portfolio-hover-content">
          <i class="icon-plus"></i>
        </div>
      </div>
      <img class="img-fluid" src="{{project.image}}" alt="">
    </a>
    <div class="portfolio-caption">
      <h4>{{project.name}}</h4>
      <p class="text-muted">{{project.category}}</p>
    </div>
  </div> -->
</div>